// delReportingTab/slice.js

import { delReportingTabUIInitialState } from "./uiLandingPageDelReportingTabState";
import { makeDelReportingTabUIActions } from "./uiLandingPageDelReportingTabActions";

export const createDelReportingTabUISlice = (set, get) => ({
  delReportingTabUI: delReportingTabUIInitialState,
  delReportingTabUIActions: Object.freeze(
    makeDelReportingTabUIActions(set, get)
  ),
});
